import '../styles/separation.css'

function Separation3() {
    return (
        <div id="separation1_displayx">
            <div id='separation1x'>
                <hr id='separation2_x'/>
            </div>
        </div>
    )
}

export default Separation3